import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/JwtService";
import { number } from "yup";
/**
 * @description service to call HTTP request via Axios
 */
class infraService {
    /**
     * @description initialize vue axios
     */
    static init(app) {
        infraService.vueInstance = app;
        if (!infraService.vueInstance.axios)
            infraService.vueInstance.use(VueAxios, axios);
        infraService.BaseUrl = import.meta.env.VITE_INFRA_URL;
    }
    /**
     * @description set the default HTTP request headers
    */
    static setHeader() {
        infraService.vueInstance.axios.defaults.headers.common["Authorization"] = "Bearer " + JwtService.getToken();
        infraService.vueInstance.axios.defaults.headers.common["Accept"] =
            "application/json";
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static query(resource, params) {
        return infraService.vueInstance.axios.get(`${infraService.BaseUrl}/${resource}`, params);
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param slug: string
     * @returns Promise<AxiosResponse>
     */
    static get(resource, slug = "") {
        return infraService.vueInstance.axios.get(`${infraService.BaseUrl}/${resource}/${slug}`);
    }
    /**
     * @description set the POST HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static post(resource, params) {
        return infraService.vueInstance.axios.post(`${infraService.BaseUrl}/${resource}`, params);
    }
    /**
    * @description Send the PUT HTTP request
    * @param resource: string
    * @param params: AxiosRequestConfig
    * @returns Promise<AxiosResponse>
    */
    static put(resource, params) {
        return infraService.vueInstance.axios.put(`${infraService.BaseUrl}/${resource}`, params);
    }
    /**
    * @description Send the DELETE HTTP request
    * @param resource: string
    * @param slug: number
    * @returns Promise<AxiosResponse>
    */
    static delete(resource, slug = number) {
        return infraService.vueInstance.axios.delete(`${infraService.BaseUrl}/${resource}/${slug}`);
    }
    /**
* @description set the POST HTTP request
* @param resource: string
* @param params: AxiosRequestConfig
* @returns Promise<AxiosResponse>
*/
    static postForm(resource, params) {
        return infraService.vueInstance.axios.post(`${infraService.BaseUrl}/${resource}`, params, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
}
export default infraService;
//********** COMENTÁRIO GERADO EM: 05/07/2022 03:01:09 **********
//
//import { App } from "vue";
//import axios from "axios";
//import VueAxios from "vue-axios";
//import JwtService from "@/core/services/JwtService";
//import { AxiosResponse, AxiosRequestConfig } from "axios";
//import { number } from "yup";
//
///**
// * @description service to call HTTP request via Axios
// */
//class infraService {
//    /**
//     * @description property to share vue instance
//     */
//    public static vueInstance: App;
//    private static BaseUrl;
//
//    /**
//     * @description initialize vue axios
//     */
//    public static init(app: App<Element>){
//        infraService.vueInstance = app;
//        infraService.vueInstance.use(VueAxios, axios);
//        //infraService.vueInstance.axios.defaults.baseURL = import.meta.env.VITE_infra_URL;
//        infraService.BaseUrl = import.meta.env.VITE_INFRA_URL;
//    }
//
//    /**
//     * @description set the default HTTP request headers
//    */
//    public static setHeader() : void {
//        infraService.vueInstance.axios.defaults.headers.common[
//            "Authorization"
//        ] = "Bearer " + JwtService.getToken();
//		infraService.vueInstance.axios.defaults.headers.common["Accept"] =
//            "application/json";
//    }
//
//    /**
//     * @description send the GET HTTP request
//     * @param resource: string
//     * @param params: AxiosRequestConfig
//     * @returns Promise<AxiosResponse>
//     */
//    public static query(
//		resource: string,
//		params: AxiosRequestConfig
//
//    ) : Promise<AxiosResponse> {
//        return infraService.vueInstance.axios.get(`${infraService.BaseUrl}/${resource}`, params);
//    }
//
//    /**
//     * @description send the GET HTTP request
//     * @param resource: string
//     * @param slug: string
//     * @returns Promise<AxiosResponse>
//     */
//    public static get(
//        resource: string,
//        slug = "" as string
//    ): Promise<AxiosResponse> {
//        return infraService.vueInstance.axios.get(`${infraService.BaseUrl}/${resource}/${slug}`);
//    }
//
//    /**
//     * @description set the POST HTTP request
//     * @param resource: string
//     * @param params: AxiosRequestConfig
//     * @returns Promise<AxiosResponse>
//     */
//    public static post(
//        resource: string,
//        params: AxiosRequestConfig
//    ): Promise<AxiosResponse> {
//        return infraService.vueInstance.axios.post(`${infraService.BaseUrl}/${resource}`, params);
//    }
//
//    /**
//    * @description Send the PUT HTTP request
//    * @param resource: string
//    * @param params: AxiosRequestConfig
//    * @returns Promise<AxiosResponse>
//    */
//    public static put(
//        resource: string,
//        params: AxiosRequestConfig
//    ): Promise<AxiosResponse> {
//        return infraService.vueInstance.axios.put(`${infraService.BaseUrl}/${resource}`, params);
//    }
//
//    /**
//    * @description Send the DELETE HTTP request
//    * @param resource: string
//    * @param slug: number
//    * @returns Promise<AxiosResponse>
//    */
//    public static delete(
//        resource: string,
//        slug = number
//    ): Promise<AxiosResponse> {
//        return infraService.vueInstance.axios.delete(`${infraService.BaseUrl}/${resource}/${slug}`);
//    }
//
//
//}
//
//export default infraService;
//
//
//********** FIM DO COMENTÁRIO **********
//# sourceMappingURL=infraService.js.map